import React from 'react'
import { useTranslation } from 'react-i18next'
import { LegalCard } from '@/features/legal/components/Elements'

export const LicenceAgreementContainer = () => {
  const { t } = useTranslation()

  return <LegalCard title={t('licence_agreement')}>{null}</LegalCard>
}
